import React, { useEffect, useState, useRef } from "react";
import format from "date-fns/format";
import { useSelector } from "react-redux";
import api from "../../Utils/api";

const FeedMessage = ({
  postId,
  type,
  author,
  createdAt,
  locations,
  users,
  content,
  confirmedUsers,
  allowComment,
  requireConfirm,
  comments,
  onCommentAdded,
}) => {
  const user = useSelector((state) => state.user.user);

  const [commentText, setCommentText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!commentText.trim()) return;

    setIsSubmitting(true);

    try {
      const res = await api.post("/newsfeed/comment/admin", {
        content: commentText,
        author: user._id,
        parentID: postId, // adjust depending on how you're linking comments to posts
        type: "comment",
      });

      if (res.data.success) {
        setCommentText("");
        if (onCommentAdded) onCommentAdded(res.data.comment);
      }
    } catch (err) {
      console.error("Failed to submit comment", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full bg-white p-4 rounded-lg border-gray-1 border border-[#ebebee] mb-4">
      {/* Sender Info */}
      {type === "main_post" ? (
        <div className="flex items-center mb-2">
          <div className="w-[44px] h-[44px] bg-[#f9f9fb] rounded-full flex items-center justify-center mr-2">
            <span className="font-sans text-[20px] font-semibold leading-[24px]">
              {author.firstName && author.firstName.charAt(0).toUpperCase()}
              {author.lastName && author.lastName.charAt(0).toUpperCase()}
            </span>
          </div>
          <div>
            <span className="font-bold text-gray-600">
              {author.preferredName}
            </span>
            <div className="flex items-center">
              <p className="text-gray-500 text-sm mr-4">
                {format(createdAt, "MMM dd, yyyy hh:mm a")}{" "}
                <span className="text-gray-600"></span>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center mb-2">
          <div className="w-[44px] h-[44px] bg-[#f9f9fb] rounded-full flex items-center justify-center mr-2">
            <span className="font-sans text-[20px] font-semibold leading-[24px]">
              AA
            </span>
          </div>
          <div>
            <span className="font-bold text-gray-600">
              System Administrator
            </span>
            <div className="flex items-center">
              <p className="text-gray-500 text-sm mr-4">
                {format(createdAt, "MMM dd, yyyy hh:mm a")}{" "}
                <span className="text-gray-600"></span>
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Message Content */}
      <div className="text-gray-800 mb-4 px-12 py-4 text-grey-400 whitespace-pre-line">
        {content}
      </div>

      {/* Read Confirmation */}
      {/* {requireConfirm && (
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center text-green-600 ml-12">
            <svg
              className="w-5 h-5 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
            <span>Confirmed read</span>
          </div>
          <span className="text-gray-500 text-sm mr-4">
            {confirmedUsers.length}/{users.length} have confirmed
          </span>
        </div>
      )} */}
      {/* <div className="items-center border-t pt-2">
        {comments?.length > 0 &&
          comments.map((comment, index) => (
            <div key={index} className="flex mb-2 ml-[5%]">
              <div>
                <div className="w-[44px] h-[44px] bg-[#f9f9fb] rounded-full flex items-center justify-center mr-2">
                  <span className="font-sans text-[20px] font-semibold leading-[24px]">
                    {comment.author?.firstName &&
                      comment.author.firstName.charAt(0).toUpperCase()}
                    {comment.author?.lastName &&
                      author.lastName.charAt(0).toUpperCase()}
                  </span>
                </div>
              </div>
              <div className="bg-[#f9f9fb] px-4 py-1 rounded-tr-lg rounded-bl-lg">
                <div className="flex gap-2">
                  <div className="font-bold text-[15px] flex justify-center">
                    {comment.author?.preferredName}
                  </div>
                  <div className="text-gray-500 !text-[14px] mr-4 flex justify-center">
                    {format(comment.createdAt, "MMM dd, yyyy hh:mm a")}{" "}
                  </div>
                </div>
                <div className="text-gray-800 py-1 text-[13px]">
                  {comment.content}
                </div>
              </div>
            </div>
          ))}
      </div> */}
      {/* Comment Section */}
      {/* {allowComment && (
        <div className="flex items-center border-t pt-2">
          <div className="w-[44px] h-[44px] bg-[#f9f9fb] rounded-full flex items-center justify-center mr-2">
            <span className="font-bold">
              {user.firstName && user.firstName.charAt(0).toUpperCase()}
              {user.lastName && user.lastName.charAt(0).toUpperCase()}
            </span>
          </div>
          <input
            type="text"
            placeholder="Write a comment"
            className="flex-1 border rounded-lg p-2 mr-2 focus:outline-none focus:ring-2 focus:ring-gray-600"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSubmit();
            }}
            disabled={isSubmitting}
          />
          <button
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            Comment
          </button>
        </div>
      )} */}
    </div>
  );
};

export default FeedMessage;
